import { useEffect, useState } from 'react';
import { ReactComponent as Controls } from '../assets/controls.svg';

export function GameControls() {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setHide(true), 2000);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed pointer-events-none w-full h-full flex items-center justify-center transition-opacity ${
        hide ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="w-96">
        <Controls />
        <p className="text-gray-900 uppercase text-center mt-4 pointer-events-non">
          Fånga så många som möjligt genom att styra med tangentbordets pilar
        </p>
      </div>
    </div>
  );
}
